export class ScriptLoader {
  /**
   * Constructor
   *
   * @param options
   */
  constructor(options) {
    const { src, global } = options;
    this.src = src;
    this.global = global;
    this.isLoaded = false;
    this.script = null;
  }

  /**
   * Loads a script to via DOM
   *
   * @returns {Promise<any>}
   */
  loadScript() {
    return new Promise((resolve, reject) => {
      if (!this.script) {
        // Create script element and set attributes
        this.script = document.createElement("script");
        this.script.type = "text/javascript";
        this.script.async = true;
        this.script.src = `${this.src}`;

        // Append the script to the DOM
        const el = document.getElementsByTagName("script")[0];
        el.parentNode.insertBefore(this.script, el);
      }

      // Resolve the promise once the script is loaded
      this.script.addEventListener("load", () => {
        this.isLoaded = true;
        resolve(this.script);
      });

      // Catch any errors while loading the script
      this.script.addEventListener("error", () => {
        reject(new Error(`${this.src} failed to load.`));
      });
    });
  }

  /**
   * Main load function
   *
   * @returns {Promise<any>}
   */
  load() {
    return new Promise(async (resolve, reject) => {
      if (!this.isLoaded) {
        try {
          await this.loadScript();
          resolve(window[this.global]);
        } catch (e) {
          reject(e);
        }
      } else {
        resolve(window[this.global]);
      }
    });
  }
}
